<template>
  <b-overlay :show="bussy" rounded="sm">
    <template #overlay>
      <div class="text-center">
        <b-icon icon="stopwatch" font-scale="3" animation="throb"></b-icon
        ><br />
        <p>
          {{ calculate ? i18n[$i18n.locale].calc : i18n[$i18n.locale].loading }}
        </p>
      </div>
    </template>
    <b-overlay :show="error === true">
      <template #overlay>
        <div class="row vertical-center" v-if="error === true">
          <div>
            <h1>{{ i18n[$i18n.locale].caption }}</h1>
            <p>{{ i18n[$i18n.locale].text }}</p>
            <hr />
            <b-button
              @click="reloadPage"
              class="float-right"
              variant="primary"
              >{{ i18n[$i18n.locale].button }}</b-button
            >
          </div>
        </div>
      </template>
      <div class="container">
        <div class="row vertical-center">
          <div class="col-12">
            <div class="ratio">
              <div id="viewport" ref="viewport"></div>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </b-overlay>
</template>

<script>
import PST from "../modules/ModVip";
import ModParticipant from "../modules/ModParticipant";
import ModTan from "../modules/ModTan";
import ModError from "../modules/ModError";

export default {
  name: "ViewVip",
  data: () => {
    return {
      bussy: true,
      error: false,
      calculate: false,
      i18n: {
        de: {
          loading: "Lade VIP...",
          calc: "Berechne Ergebnis...",
          caption: "Wir bitten um Entschuldigung",
          text: 'Vermutlich gibt es Probleme mit der Internetverbindung zum VIP. Bitte versuchen Sie es noch einmal, indem Sie auf "Noch einmal versuchen" klicken oder wieder zu einem späteren Zeitpunkt versuchen.',
          button: "Noch einmal versuchen…",
        },
        en: {
          loading: "Load VIP...",
          calc: "Calculate result...",
          caption: "We apologise for the inconvenience",
          text: "There is probably an issue with the internet connection to the VIP. Please try again by clicking on ‘Try again’ or try to access the VIP at a later time.",
          button: "Try again…",
        },
        fr: {
          loading: "Charger VIP...",
          calc: "Calculer le résultat...",
          caption: "Nous vous prions de nous excuser",
          text: "Il y a probablement un problème de connexion Internet avec le VIP. Veuillez réessayer en cliquant sur « Essayer à nouveau » ou réessayer plus tard.",
          button: "Essayer à nouveau…",
        },
        it: {
          loading: "Scarica VIP...",
          calc: "Calcolare il risultato...",
          caption: "Ci scusiamo per l'inconveniente",
          text: "Probabilmente c'è un problema di connessione a Internet con il VIP. Riprovare facendo clic su “Riprova” o riprovare più tardi.",
          button: "Riprova…",
        },
      },
    };
  },
  methods: {
    initPage() {
      const self = this;
      PST.init({
        viewport: "viewport",
        locale: self.$i18n.locale,
        baseUrl: "/core",
        loaded: async () => {
          this.bussy = false;
        },
        calc: async () => {
          this.calculate = true;
          this.bussy = true;
        },
        calcDone: async () => {
          this.bussy = false;
        },
        success: async (status, result) => {
          if (status === 200) {
            ModParticipant.data.accountId = self.$specs.accountId;
            ModParticipant.data.projectId = self.$specs.projectId;
            ModParticipant.data.e = result.e;
            ModParticipant.data.s = result.s;
            ModParticipant.data.n = result.n;
            ModParticipant.data.t = result.t;
            ModParticipant.data.f = result.f;
            ModParticipant.data.j = result.j;
            ModParticipant.data.fulltype = result.type;
            if (self.$specs.tanProtected == false) {
              ModParticipant.data.tan = result.id;
            }

            if (await ModParticipant.create(ModParticipant.data)) {
              if (
                await ModTan.invalidate(
                  ModParticipant.data.tan,
                  self.$specs.accountId,
                  self.$specs.projectId
                )
              ) {
                self.$specs.withResult
                  ? self.$router.push("/result")
                  : self.$router.push("/end");
              } else {
                ModError.send({
                  module:
                    "ViewVip.cannotInvalidateTan: " + ModParticipant.data.tan,
                  code: 1,
                });
                self.$router.push("/error");
              }
            } else {
              ModError.send({
                module:
                  "ViewVip.cannotCreateParticipant: " + ModParticipant.data.tan,
                code: 2,
              });
              self.$router.push("/error");
            }
          } else {
            ModError.send({
              module: "ViewVip.noResult: " + ModParticipant.data.tan,
              code: status,
            });
            self.$router.push("/error");
          }
        },
        error: async () => {
          this.error = true;
        },
      });
    },
    reloadPage() {
      this.error = false;
      this.$router.go(0);
      this.initPage();
    },
  },
  mounted() {
    this.initPage();    
  },
};
</script>

<style>
.head {
  display: none !important;
}
</style>

<style scoped>
.view {
  position: absolute;
  width: 100%;
  top: 0px;
  bottom: 0px;
  background-color: lightgreen;
}
.vertical-center {
  min-height: 85%;
  min-height: 85vh;

  display: flex;
  align-items: center;
}
.ratio {
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
}
#viewport {
  display: block;
  height: auto;
  width: 100%;
  font-size: 80%;
}
.border {
  border: 1px solid #ddd;
}
h1 {
  font-weight: bold !important;
}
</style>
